/**
 * Feature flag: dynamic package pricing from normalized display model only (no FE LDS fare engine).
 *
 * Activate:
 *   localStorage.setItem("DYNAMIC_PACKAGE_PRICING_SOURCE", "normalized")
 * Or env:
 *   VITE_DYNAMIC_PACKAGE_PRICING_SOURCE=normalized
 */

export const DYNAMIC_PACKAGE_PRICING_SOURCE_STORAGE_KEY = "DYNAMIC_PACKAGE_PRICING_SOURCE";
export const DYNAMIC_PACKAGE_PRICING_SOURCE_NORMALIZED = "normalized";

export function getDynamicPackagePricingSource() {
  try {
    if (
      typeof import.meta !== "undefined" &&
      import.meta.env &&
      import.meta.env.VITE_DYNAMIC_PACKAGE_PRICING_SOURCE != null &&
      String(import.meta.env.VITE_DYNAMIC_PACKAGE_PRICING_SOURCE).trim() !== ""
    ) {
      return String(import.meta.env.VITE_DYNAMIC_PACKAGE_PRICING_SOURCE).trim();
    }
  } catch {
    /* ignore */
  }
  try {
    if (typeof window !== "undefined" && window.localStorage) {
      const v = window.localStorage.getItem(DYNAMIC_PACKAGE_PRICING_SOURCE_STORAGE_KEY);
      if (v != null && String(v).trim() !== "") return String(v).trim();
    }
  } catch {
    /* ignore */
  }
  return "";
}

export function isDynamicPackagePricingNormalizedEnabled() {
  return (
    getDynamicPackagePricingSource() === DYNAMIC_PACKAGE_PRICING_SOURCE_NORMALIZED
  );
}

/** תוצאה מ־calculateLDSDealFareForRoomsComposition כשמופעל מצב normalized בטאב חבילות דינמיות */
export function isDynamicPackageNormalizedPricingResult(obj) {
  return Boolean(obj && obj.dynamicPackageNormalizedOnly === true && obj.normalized);
}

/**
 * עותק deal לשמירה ב-state — dealFare / fareDetails קפואים (ללא מוטציות מחיר בפרונט).
 * פעיל רק כש־isDynamicPackagePricingNormalizedEnabled().
 */
export function sealLdsDealPriceBranchesForReadOnly(deal) {
  if (!deal || typeof deal !== "object") return deal;
  let clone;
  try {
    clone =
      typeof structuredClone === "function"
        ? structuredClone(deal)
        : JSON.parse(JSON.stringify(deal));
  } catch {
    return deal;
  }
  const freezeIf = (o) => {
    if (o && typeof o === "object") Object.freeze(o);
  };
  freezeIf(clone.dealFare);
  freezeIf(clone.fareDetails);
  if (clone.fullDeal && typeof clone.fullDeal === "object") {
    freezeIf(clone.fullDeal.dealFare);
    freezeIf(clone.fullDeal.fareDetails);
  }
  return clone;
}
